import { mount } from 'svelte';
import App from './app/App.svelte';

const target = document.getElementById('app');
if (!target) {
  throw new Error('#app要素が見つかりません');
}

const app = mount(App, { target });

export default app;
